// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for authentication as an object that can be mutated
export const authState = $state({});

// Function to reset authentication state
export function resetAuth() {
    // Instead of reassigning authState, clear its properties
    authState.user = null;
    authState.team = null;
}

// Function to update team information
export function updateTeam(teamInfo) {
    authState.team = teamInfo;
}

// Function to update user information
export function updateUser(userInfo) {
    authState.user = userInfo;
}

// Resolves the first time setAuth() delivers a plan, so plan checks made during startup can wait for it
let resolvePlanReady;
const planReady = new Promise((resolve) => {
    resolvePlanReady = resolve;
});

export function whenPlanReady() {
    return planReady;
}

// Function to set entire auth state
export function setAuth(auth) {
    // Update properties individually instead of reassigning
    Object.keys(auth).forEach(key => {
        authState[key] = auth[key];
    });
    if (authState.plan || authState.entitlements) resolvePlanReady();
}

// Add getter functions if needed
export function getAuthState() {
    return authState;
}